// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_dh-0";
export var actionModalContentContainer = "_dh-1";
export var createTagButton = "_dh-2";
export var footerContainer = "_dh-7";
export var fullWidthDivider = "_dh-3";
export var hasCreateTagButton = "_dh-4";
export var noCreateTagButton = "_dh-5";
export var tagsContainer = "_dh-6";
export var tagsModalContentContainer = "_dh-8";